import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CardModule } from '../../card/card.module';
import { DynamicRenderSharedModule } from '../../shared/shared.module';
import { ValidationsModule } from '../../validations/validations.module';

import { PageActionBarComponent } from './page-action-bar/page-action-bar.component';
import { PageAlertComponent } from './page-alert/page-alert.component';
import { PageCardsComponent } from './page-cards/page-cards.component';
import { CorePageBaseComponent } from './core-page-base.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { PageLayoutComponent } from './page-layout/page-layout.component';
import { PageValidationComponent } from './page-validation/page-validation.component';
import { PageWorkflowProgressComponent } from './page-workflow-progress/page-workflow-progress.component';
import { PageModalComponent } from './page-modal-popup/page-modal-popup.component';
import { RouterModule } from '@angular/router';

const components = [
  CorePageBaseComponent,
  PageActionBarComponent,
  PageAlertComponent,
  PageCardsComponent,
  PageHeaderComponent,
  PageValidationComponent,
  PageLayoutComponent,
  PageModalComponent,
  PageWorkflowProgressComponent
];

@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, CardModule, ValidationsModule, DynamicRenderSharedModule, RouterModule]
})
export class PageSharedModule {}
